export const mapEntitiesFromSnapshot = snapshot =>
    snapshot.docs.map(mapEntityFromDoc);

export const mapEntityFromDoc = doc => ({
    ...doc.data(),
    id: doc.id,
});

export const mapFoundPromotionCodeFromSnapshot = snapshot => {
    const foundEntities = mapEntitiesFromSnapshot(snapshot);
    return {
        exist: foundEntities.length > 0,
        ...foundEntities[0]
    }
};
